





















































































































































import { fetchVerificacion } from '../fetchVerificacion';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';

import { Validator } from 'vee-validate';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { Funcionalidades } from '@/config/funcionalidades';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { AccionesInterface, IAccionesPadre } from '@/interfaces/Acciones';

import {
  GridApi,
  ColumnApi,
  ColDef,
  CellContextMenuEvent,
  GridReadyEvent,
  SelectionChangedEvent,
  SelectionController,
  RowNode,
  CellClickedEvent,
  RowSelectedEvent,
  CellClassParams,
} from 'ag-grid-community';
import { differenceBy } from 'lodash';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    DatePicker,
  },
})
export default class InformacionGeneral extends ComponenteBaseStepper {
  @Prop({ required: true }) editedItem: any;

  estados = ['Solicitado', 'Anulado'];
  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];

  cambiarConfirmados(cantidad: number) {
    this.formFields.cantidadEquiposConfirmados.value = cantidad;
  }

  cambiarCantSims(cantidad: number) {
    this.formFields.cantidadSimCards.value = cantidad;
  }

  async getSolicitud() {
    let self = this;
    this.loadingService.showLoading();
    return fetchVerificacion(
      {
        solicitud: this.editedItem,
      },
      'conecta_verificacion_baja_cliente/inicio'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error al cargar las solicitudes', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  motivoId: number;
  async cargarNumero() {
    let data = await this.getSolicitud();
    this.formFields.numero.value = data.bajaclinumero;
    this.formFields.fechaCreacion.value = data.bajaclifecha_alta
      ? moment(data.bajaclifecha_alta).format('YYYY-MM-DD HH:mm')
      : '';
    this.formFields.usuarioCreacion.value = data.full_name_creacion;
    this.motivoId = Number(data.motiid);
    this.formFields.motivoTipo.value = data.motiname;
    this.formFields.observacion.value = data.bajacliobs;
    this.formFields.tramo.value = moment(data.bajaclitramo).format('YYYY-MM');
    this.formFields.cantidadClientes.value = data.bajaclicant;
    this.formFields.cantidadEquipos.value = data.bajaclicant_equipos;
    this.formFields.cantidadPerifericos.value = data.bajaclicant_perifericos;
    this.formFields.estado.value = data.estado;
    this.formFields.cantidadSimCards.value = data.sbajacantsim;
    this.formFields.cantidadEquiposConfirmados.value =
      data.bajaclicant_equipo_real;

    if (data.estado == 'Ejecutado') {
      this.$emit('ejecutado', true);
    }

    this.formFields.fechaEjecuta.value = moment(
      data.bajaclifecha_ejecuta
    ).format('YYYY-MM-DD HH:mm');

    this.formFields.usuarioEjecuta.value =
      data.full_name_ejecuta != ' ' ? data.full_name_ejecuta : '';
  }

  mounted() {
    this.cargarNumero();
  }

  formFields: {
    numero: any;
    fechaCreacion: any;
    usuarioCreacion: any;
    motivoTipo: any;
    observacion: any;
    tramo: any;
    cantidadClientes: any;
    cantidadEquipos: any;
    cantidadPerifericos: any;
    fechaEjecuta: any;
    usuarioEjecuta: any;
    estado: any;
    cantidadSimCards: any;
    cantidadEquiposConfirmados: any;
  } = {
    numero: {
      label: 'Número',
      value: '',
    },
    fechaCreacion: {
      label: 'Fecha Creación',
      value: '',
    },
    usuarioCreacion: {
      label: 'Usuario Creación',
      value: '',
    },
    motivoTipo: {
      label: 'Motivo Tipo',
      value: '',
    },
    observacion: {
      label: 'Observación',
      value: '',
    },
    tramo: {
      label: 'Tramo',
      value: '',
    },
    cantidadClientes: {
      label: 'Cantidad Clientes',
      value: 0,
    },
    cantidadEquipos: {
      label: 'Cantidad Equipos',
      value: 0,
    },
    cantidadPerifericos: {
      label: 'Cantidad Periféricos',
      value: 0,
    },
    estado: {
      label: 'Estado',
      value: '',
    },
    fechaEjecuta: {
      label: 'Fecha Ejecuta',
      value: '',
    },
    usuarioEjecuta: {
      label: 'Usuario Ejecuta',
      value: '',
    },
    cantidadSimCards: {
      label: 'Cantidad Sim Cards',
      value: 0,
    },
    cantidadEquiposConfirmados: {
      label: 'Cantidad Equipos Confirmados',
      value: 0,
    },
  };

  // Globales
  $snotify: any;
  dialog: boolean = false;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  disabledAccion: boolean = false;
  mensajeConfirmacion: any = '';

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  async editarSolicitud(): Promise<boolean> {
    let self = this;
    this.loadingService.showLoading();
    return fetchVerificacion(
      {
        solicitud: this.editedItem,
        usuario: JSON.parse(window.localStorage.user).id,
        cantidadEquipos: this.formFields.cantidadEquiposConfirmados.value,
        cantidadSims: this.formFields.cantidadSimCards.value,
      },
      'conecta_verificacion_baja_cliente/editar_solicitud_general'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        return false;
      })
      .catch((error: any) => {
        self.$snotify.error(error, {
          timeout: 3000,
        });
        return false;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return false;
      });
  }
}
